import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbsB2B2C = [{ title: "menu_sidebar_partner" }, { title: "menu_sidebar_partner_b2b2c" }];
const parentBreadCrumbsb2b = [
  { title: "menu_sidebar_partner" },
  { title: "menu_sidebar_partner_b2b" },
  { title: "partner_b2b_heading_partner_organization", link: "/partner/b2b" }
];

const PartnerProvider = Loadable({
  loader: () => import("../../../container/partner"),
  loading() {
    return <Loader />;
  }
});
const PartnerProviderListing = Loadable({
  loader: () => import("../../../container/partner/listing"),
  loading() {
    return <Loader />;
  }
});
const IncentiveRequests = Loadable({
  loader: () => import("../../../container/partner/incentiveRequests/listing"),
  loading() {
    return <Loader />;
  }
});

IncentiveRequests;

const PartnerB2BListing = Loadable({
  loader: () => import("../../../container/bac/listing"),
  loading() {
    return <Loader />;
  }
});

const PartnerB2BProvider = Loadable({
  loader: () => import("../../../container/bac"),
  loading() {
    return <Loader />;
  }
});

const PartnerIncentiveManagement = Loadable({
  loader: () => import("../../../container/partner/incentiveManagement"),
  loading() {
    return <Loader />;
  }
});
export const PartnerProviderRoutes: IRoute[] = [
  {
    path: "/partner/details/:id?",
    element: <PartnerProvider />,
    handle: {
      crumbs: [
        ...parentBreadCrumbsB2B2C,
        {
          title: "menu_sidebar_takaful_bazaar_partner",
          link: "/partner"
        }
      ]
    }
  },
  {
    path: "/partner",
    element: <PartnerProviderListing />,
    handle: {
      crumbs: [
        ...parentBreadCrumbsB2B2C,
        {
          title: "menu_sidebar_takaful_bazaar_partner",
          link: "/partner"
        }
      ]
    }
  },
  {
    path: "/partner/b2b",
    element: <PartnerB2BListing />,
    handle: {
      crumbs: [...parentBreadCrumbsb2b]
    }
  },
  {
    path: "/partner/b2b/details/:id?",
    element: <PartnerB2BProvider />,
    handle: {
      crumbs: [...parentBreadCrumbsb2b]
    }
  },
  {
    path: "/partner/incentive-management",
    element: <PartnerIncentiveManagement />,
    handle: {
      crumbs: [...parentBreadCrumbsB2B2C, { title: "menu_sidebar_partner_incentive_management" }]
    }
  },
  {
    path: "/partner/encashment-request",
    element: <IncentiveRequests />,
    handle: {
      crumbs: [
        ...parentBreadCrumbsB2B2C,
        {
          title: "menu_sidebar_partner_encashment_request"
        }
      ]
    }
  }
];
